<template lang="pug">
  .right_col(role='main')
    .page-title
      .title_left
        h2 【{{inquiry.title}}】への返信
    .x_panel
      .x_content
        .customerchat
          #chat-frame
            div.chat-inframe
              .chat-area(v-for='(message, index) in messages' :message_id='message.id' :index='index')
                // 問い合わせた人のチャット
                p.chat-talk(v-show='!message.user_id')
                  span.talk-icon
                    img(:src='message.clientSrc')
                  small {{message.created_at}}
                  pre
                    span.talk-content {{message.text}}
                  //添付ファイルダウンロードボタン
                  button.myattachments.btn-link(v-show='message.file_name'
                  @click="download(message.no, message.file_name)") {{message.file_name}}
                // システム側の人のチャット
                p.chat-talk.client(v-show='message.user_id')
                  span.talk-icon.company
                    i.fa.fa-building-o(aria-hidden='true')
                  small {{message.created_at}}
                  pre
                    span.talk-content {{message.text}}
                  //添付ファイルダウンロードボタン
                  button.yourattachments.btn-link(v-show='message.file_name'
                  @click="download(message.no, message.file_name)") {{message.file_name}}
              textarea.chatbox(placeholder='返信内容を入力してください', rows='5' v-model="text" style="margin-bottom: 10px" v-show='sendable')
              .attachmentfile(style="float: left" v-show='sendable')
                button(@click="fileSelect" style="float: left") ファイル選択
                input(type='file' id="file" style="display: none")
                p(v-show="file" style="float: left") {{ file }}
                p.small(v-show="!file" style="float:left") 1ファイルのみ添付可能です
                  br
                  | 添付できるファイルは最大1MBまでとなります
              .action(style="float: right" v-show='sendable')
                .send_button
                  button.btn.btn-info(type='button' @click='send' v-show='text') 送&nbsp;&nbsp;信
              .sign(v-show='sendable' style='clear: both;')
                select.signselect.selectitems(v-model='sign.default_signature')
                  option(value='' v-show='form.default_signature') フォーム署名
                  option(value='1' v-show='sign.signature_title1 && sign.signature1') {{sign.signature_title1}}
                  option(value='2' v-show='sign.signature_title2 && sign.signature2') {{sign.signature_title2}}
                  option(value='3' v-show='sign.signature_title3 && sign.signature3') {{sign.signature_title3}}
                pre
                  p.sign-area(v-show='sign.default_signature == ""') {{form.default_signature}}
                  p.sign-area(v-show='sign.default_signature == "1"') {{sign.signature1}}
                  p.sign-area(v-show='sign.default_signature == "2"') {{sign.signature2}}
                  p.sign-area(v-show='sign.default_signature == "3"') {{sign.signature3}}
</template>

<script>
import $ from 'jquery'
import bus from '@/service/EventBus'
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import Message from '@/service/Message'

export default {
  name: 'dashborad',
  data () {
    return {
      file: '',
      sendable: false,
      inquiry: [],
      text: '',
      messages: [],
      form: [],
      sign: []
    }
  },
  mounted () {
    bus.$emit('select_menu', 'message')

    // fileの容量チェック
    let self = this
    this.$nextTick(function () {
      $('#file').change(function () {
        let file = $(this).prop('files')[0]
        if (file) {
          if (file.size > 1024000) {
            Message.error('ファイルの容量が大きすぎます')
            $(this).val('') // 選択を解除
            self.file = ''
          } else {
            self.file = file.name
          }
        } else {
          self.file = ''
        }
      })
    })

    // データ取得
    this.bind()
  },
  methods: {
    // データバインド
    bind () {
      this.$nextTick(() => { Loader.show() })
      // パラメータはinquiry id
      Request.create(true).get('/chat/' + this.$route.params.id + '/messages')
        .then((res) => {
          // 問い合わせ
          this.inquiry = res.data.inquiry
          // クライアントの頭文字を取得
          let fClient = ''
          if (res.data.inquiry.client_name) {
            fClient = res.data.inquiry.client_name.charAt(0)
          }
          for (let key in res.data.messages) {
            // message情報にクライアントアイコン用srcを付与する
            res.data.messages[key].clientSrc = 'http://placehold.jp/28/1abb9c/333333/50x50.png?text=' + fClient
          }
          this.messages = res.data.messages
          this.form = res.data.form
          // 署名のデフォルト設定値
          this.sign = res.data.sign[0]
          this.sendable = res.data.sendable
          this.$nextTick(() => { Loader.hide() })
        }).catch((err) => {
          Message.error(err.response.data.message)
          this.$nextTick(() => { Loader.hide() })
        })
    },
    send () {
      let self = this
      $.confirm({
        title: '',
        content: '返信しますか？',
        columnClass: 'col-md-2 col-md-offset-5',
        type: 'dark',
        typeAnimated: true,
        buttons: {
          はい: {
            btnClass: 'btn-dark',
            action: function () {
              self.$nextTick(() => { Loader.show() })

              let datas = new FormData()
              datas.append('text', self.text)
              if (self.file) {
                datas.append('file', $('#file').prop('files')[0])
              }
              // 署名の確認
              if (self.sign.default_signature === '1') {
                datas.append('sign', self.sign.signature1)
              } else if (self.sign.default_signature === '2') {
                datas.append('sign', self.sign.signature2)
              } else if (self.sign.default_signature === '3') {
                datas.append('sign', self.sign.signature3)
              } else {
                datas.append('sign', self.form.default_signature)
              }

              // パラメータはinquiry id
              Request.create(true).put('/chat/' + self.$route.params.id + '/manage', datas)
                .then((res) => {
                  Message.success('送信しました。')
                  // 本文および添付ファイルをからにする
                  self.text = ''
                  $('input[name=attach]').val('')
                  self.file = ''
                  self.bind()  // リロード
                }).catch((err) => {
                  Message.error(err.response.data.message)
                  self.text = ''
                  $('input[name=attach]').val('')
                  self.file = ''
                  self.$nextTick(() => { Loader.hide() })
                })
            }
          },
          いいえ: function () {
          }
        }
      })
    },
    fileSelect () {
      $('#file').trigger('click')
    },
    download (no, filename) {
      // 添付ファイルダウンロード
      let token = this.$store.user.access_token
      Request.create(true).get('/chat/' + this.$route.params.id + '/download/' + no + '/check')
        .then((res) => {
          // Request.create(true).get('/chat/' + this.$route.params.id + '/download/' + no + '/check')
          let downloadUrl = Request.httphost(true) + '/chat/' + this.$route.params.id + '/download/' + no + '?Authorization=' + token
          bus.$emit('download', downloadUrl)
        }).catch((err) => {
          Message.error(err.response.data.message)
          this.$nextTick(() => { Loader.hide() })
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.navbar-inverse
  background-image: none
.customerchat
  min-height: calc(100vh - 150px) !important
  #chat-frame
    margin: 20px auto
    .chat-inframe
      overflow: auto
    textarea
      resize: vertical
      background-color: #c0e6e3
  .send_button
    text-align: center
    margin-bottom: 20px
    .btn
      margin: 0
@media screen and (max-width: 736px)
  .customerchat
    padding: 10px
    #chat-frame
      width: 100%
      .chat-inframe
        bottom: 0
.minimize-btn
  color: #FFF
p.chattitle
  float: right
  color: #999
.chat-inframe
  height: 80%
  overflow: auto
  padding: 0 10px
.chat-talk
  overflow: hidden
  margin: 0 0 1em 0
  padding: 0
  span
    display: block
    margin: 0
    padding: 0
  .company
    border-radius: 30px
    background-color: #ff0076
    .fa-building-o
      font-size: 30px
      padding: 10px 13px
      border: 2px solid #fff
      border-radius: 50%
      color: #000000
  span.talk-icon
    margin-top: 15px
  .talk-icon
    float: left
    width: auto
  .talk-content
    position: relative
    box-sizing: border-box
    width: calc(100% / 2)
    min-height: 50px
    border-radius: 10px
    background-color: #fff
    margin: 0 auto 0 20px
    padding: 1em
  .talk-icon img
    max-width: 100%
    height: auto
    vertical-align: bottom
    border: 2px solid #fff
    border-radius: 50%
  .talk-content:before
    position: absolute
    top: 15px
    left: -20px
    display: block
    width: 0
    height: 0
    content: ''
    border: 10px solid transparent
    border-right-color: #fff
  small
    margin-left: 20px
  &.client
    .talk-icon
      float: right
    .talk-content
      margin: 0 20px 0 auto
      color: #000
      background: #f7f7f7
      &:before
        right: -20px
        left: auto
        border-color: transparent
        border-left-color: #f7f7f7
    small
      margin-left: 585px
  .myattachments
    float: left
    margin-left: 290px
  .yourattachments
    float: right
    margin-right: 65px
textarea.chatbox
  width: 100%
  height: 100%
  margin-top: 10px
  padding: 5px
  overflow: auto
  font-size: initial
  border-top: solid 1px #bbb
  border-bottom: none
  border-right: none
  border-left: none
  border-radius: 0
  background-color: transparent
  &:focus
    outline-style: none
    box-shadow: none !important
.attachmentfile
  text-align: left
  padding: 10px

pre
  padding: 0 !important
  border: none !important
  background: none !important
  white-space: pre-wrap
</style>



// WEBPACK FOOTER //
// Chat.vue?3aa5a3ec